import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Stars from "../pages/stars/page";
import MovieDetail from "../pages/movie/detail/page";
import StarDetail from "../pages/star/detail/page";
import News from "../pages/news/page";
import About from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category",
        element: <Category />,
      },
      {
        path: "stars",
        element: <Stars />,
      },
      {
        path: "movie/:id",
        element: <MovieDetail />,
      },
      {
        path: "star/:id",
        element: <StarDetail />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "404",
        element: <NotFound />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;